export enum Viewport {
  SMALL_MOBILE = 'SMALL_MOBILE',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
  WIDE = 'WIDE',
}

export enum Breakpoints {
  SMALL_MOBILE = 575,
  MOBILE = 768,
  TABLET = 1024,
  DESKTOP = 1500,
}
